import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { TopShopClosedMessage } from "./TopShopRegistrationClosed";
import { useTopShopRegistration } from "./useTopShopRegistration";

export function TopShopNotAppliedCard() {
  const { isOpen, isLoading, closedMessage } = useTopShopRegistration();
  const closed = !isLoading && !isOpen;
  return (
    <Card>
      <CardContent className="flex flex-col items-start gap-4 p-6">
        <p>You have not applied to the Top Shop Challenge yet.</p>
        {closed ? (
          <>
            <TopShopClosedMessage message={closedMessage} />
            <Button asChild><Link to="/dashboard">Go to your dashboard</Link></Button>
          </>
        ) : (
          <Button asChild><Link to="/topshop#apply">Apply now</Link></Button>
        )}
      </CardContent>
    </Card>
  );
}
